import React from "react";
import CustomModal from "components/custom-modal/CustomModal";
import Button from "components/button/Button";
import { CheckCircleIcon, AlertCircleIconV1 } from "images/image-component";
import "./success-modal.css";

interface Props {
  isOpen: boolean;
  message: string;
  handleClose: () => void;
  /** A secondary, non-fatal caveat riding along with the success (e.g. a follow-up sync that
   *  failed) — the operation itself still succeeded, so this renders as a note, not an error. */
  warning?: string;
}

function SuccessModal({ isOpen, message, handleClose, warning }: Props) {
  return (
    <CustomModal isOpen={isOpen} handleClose={handleClose}>
      <div className="v1-success-modal">

        <div className="v1-success-icon">
          <CheckCircleIcon />
        </div>

        <h3 className="v1-success-title">Success</h3>
        <p className="v1-success-msg">{message}</p>

        {warning && (
          <div className="v1-success-warning">
            <AlertCircleIconV1 size={16} />
            <span>{warning}</span>
          </div>
        )}

        <div className="v1-success-actions">
          <Button variant="subtle" onClick={handleClose}>
            Close
          </Button>
        </div>

      </div>
    </CustomModal>
  );
}

export default SuccessModal;
